// extracted by mini-css-extract-plugin
var _1 = "sQuqq";
var _2 = "Xez21";
export { _1 as "addLicensesModal", _2 as "addLicensesText" }
